import React from 'react';
import PropTypes from 'prop-types';

// eslint-disable-next-line import/no-named-as-default
import SeatMapMapbox from '@stubhub/react-seat-maps';
import {connect} from '@stubhub/react-store-provider';

import {query} from '../../../../modules/react-query';

import controller from './controller';

import './seatMapMapbox.scss';

@connect(controller)
@query({
  multiSectionSelect: 'multiSectionSelect',
  showBYO: 'byo',
  quantity: 'qty',
  byoQuantity: 'byo_qty',
  listingId: 'ticket_id',
  priceWithFees: 'priceWithFees',
  listingCategory: 'categ',
  excludeCategory: 'excl',
  deliveryType: 'dt',
  sort: 'sort',
  sortKey: 'sortKey',
  sliderMin: 'sliderMin',
  sliderMax: 'sliderMax',
  sectionIdList: 'sid',
  zoneIdList: 'zid',
  listingRows: 'rid',
  mapType: 'mapType',
})
class SeatMapQueryParamWrapper extends React.Component {
  render() {
    const {mapType: initialMapType, mapTypeFromState} = this.props;
    const mapType = initialMapType || mapTypeFromState;
    const newProps = {...this.props, mapType};

    return <SeatMapMapbox {...newProps} />;
  }
}

SeatMapQueryParamWrapper.propTypes = {
  mapType: PropTypes.string,
  mapTypeFromState: PropTypes.string,
};
export default SeatMapQueryParamWrapper;
